/**
 * Textos de la UI de escaneo por camara. Se mantienen en la capa eager (sin
 * importar ZXing) para que el boton pueda reportar el error de contexto no
 * seguro sin necesidad de descargar el chunk del escaner.
 */
export const CAMERA_SCAN_MESSAGES = {
  insecureContext:
    'La camara no esta disponible en esta direccion. Abre el WMS con https:// (o desde localhost) para poder escanear.',
  notAllowed:
    'No diste permiso para usar la camara. Habilitala en los permisos del sitio en tu navegador y vuelve a intentar.',
  notFound:
    'No encontramos ninguna camara en este dispositivo. Usa el lector fisico o escribe el codigo a mano.',
  notReadable:
    'La camara esta siendo usada por otra aplicacion. Cierrala y vuelve a intentar.',
  overconstrained:
    'No pudimos usar la camara trasera de este dispositivo. Vuelve a intentar o escribe el codigo a mano.',
  aborted: 'Se interrumpio el acceso a la camara. Vuelve a intentar.',
  playbackBlocked:
    'El navegador no pudo iniciar el video. Vuelve a intentar tocando el boton de escanear.',
  timeout:
    'No pudimos leer ningun codigo. Acerca la etiqueta, mejora la iluminacion y vuelve a intentar.',
  unknown: 'No pudimos abrir la camara. Vuelve a intentar o escribe el codigo a mano.'
}

/** true si el navegador expone la API de camara (requiere contexto seguro). */
export const isCameraSupported = (): boolean =>
  typeof navigator !== 'undefined' &&
  !!navigator.mediaDevices &&
  typeof navigator.mediaDevices.getUserMedia === 'function'

/**
 * Traduce el error de getUserMedia / ZXing al mensaje que ve el operario.
 * Los nombres legacy (PermissionDeniedError, TrackStartError, etc.) siguen
 * apareciendo en navegadores viejos, por eso estan contemplados.
 */
export const mapMediaErrorToMessage = (error: unknown): string => {
  // navigator.mediaDevices undefined hace que ZXing tire un TypeError crudo.
  if (error instanceof TypeError) return CAMERA_SCAN_MESSAGES.insecureContext

  const name = (error as { name?: string })?.name ?? ''

  switch (name) {
    case 'NotAllowedError':
    case 'PermissionDeniedError':
      return CAMERA_SCAN_MESSAGES.notAllowed
    case 'NotFoundError':
    case 'DevicesNotFoundError':
      return CAMERA_SCAN_MESSAGES.notFound
    case 'NotReadableError':
    case 'TrackStartError':
      return CAMERA_SCAN_MESSAGES.notReadable
    case 'OverconstrainedError':
    case 'ConstraintNotSatisfiedError':
      return CAMERA_SCAN_MESSAGES.overconstrained
    case 'AbortError':
      return CAMERA_SCAN_MESSAGES.aborted
    case 'SecurityError':
      return CAMERA_SCAN_MESSAGES.insecureContext
    default:
      break
  }

  // ZXing rechaza con un Error genérico cuando expira tryPlayVideoTimeout.
  const message = (error as { message?: string })?.message ?? ''
  if (/timeout|play/i.test(message)) return CAMERA_SCAN_MESSAGES.playbackBlocked

  return CAMERA_SCAN_MESSAGES.unknown
}
